import { render, staticRenderFns } from "./OrderImage.vue?vue&type=template&id=1a0c5b8f"
import script from "./OrderImage.vue?vue&type=script&lang=js"
export * from "./OrderImage.vue?vue&type=script&lang=js"
import style0 from "./OrderImage.vue?vue&type=style&index=0&id=1a0c5b8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports